import { render, staticRenderFns } from "./courseStudent.vue?vue&type=template&id=c6203874&scoped=true"
import script from "./courseStudent.vue?vue&type=script&lang=js"
export * from "./courseStudent.vue?vue&type=script&lang=js"
import style0 from "./courseStudent.vue?vue&type=style&index=0&id=c6203874&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6203874",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6203874')) {
      api.createRecord('c6203874', component.options)
    } else {
      api.reload('c6203874', component.options)
    }
    module.hot.accept("./courseStudent.vue?vue&type=template&id=c6203874&scoped=true", function () {
      api.rerender('c6203874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/courseStudent.vue"
export default component.exports